<section>
    <app-keywords-cloud-filter (filterEmmiter)="setFilter($event)"></app-keywords-cloud-filter>
    <app-keywords-cloud-list [filter]="filter" *ngIf="filter"></app-keywords-cloud-list>
  </section>